import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const paymentErrorBoxStyles = {
  container: {
    padding: theme.spacing.medium,
    backgroundColor: theme.colors.errorBackground,
    border: `1px solid ${theme.colors.error}`,
    borderRadius: theme.radius.md,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
  } as CSSProperties,

  title: {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.error,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
  } as CSSProperties,

  message: {
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.error,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
  } as CSSProperties,
};
